import { FC } from 'react'

import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'

import { NAVIGATE_BACK_INDEX } from 'src/Constants/constants'
import { BreadCrumbItem, Breadcrumb } from 'src/Components/Breadcrumb'
import { AdsFAQ } from 'src/Components/AdsFAQ'
import { ArtistRoutesEnum } from 'src/Router/ArtistComponentsNewUI'

import { Strategy } from './SelectStrategy'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0 auto;
  width: 100%;
  max-width: 960px;
  height: 100%;
  gap: 16px;
`

export const CreateAdsCampaign: FC = () => {
  const navigate = useNavigate()
  const items: BreadCrumbItem[] = [
    {
      title: 'Campaigns',
      path: ArtistRoutesEnum.CampaignsList,
    },
    {
      title: 'Campaign type',
      path: ArtistRoutesEnum.ChooseCreateCampaignPlatform,
    },
    {
      title: 'Strategy type',
      path: '',
    },
  ]

  const onBreadcrumbButtonClick = (): void => {
    navigate(NAVIGATE_BACK_INDEX)
  }
  return (
    <Container>
      <Breadcrumb items={items} onButtonClick={onBreadcrumbButtonClick} />
      <Strategy />
      <AdsFAQ />
    </Container>
  )
}
